import shot1 from '../images/screenshots/shot-1.png';
import shot2 from '../images/screenshots/shot-2.png';
import shot3 from '../images/screenshots/shot-3.png';
import shot4 from '../images/screenshots/shot-4.png';
import shot5 from '../images/screenshots/shot-5.png';

const SHOTS = [shot1, shot2, shot3, shot4, shot5];

export default function Gallery() {
  return (
    <section className="section" id="gallery">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Take a look</span>
          <h2>Straight from the App Store</h2>
          <p>A quick peek at Klingua in action on iPhone.</p>
        </div>
      </div>
      <div className="container">
        <div className="gallery-scroll">
          {SHOTS.map((s, i) => (
            <div className="g" key={i}><img src={s} alt={'Klingua screenshot ' + (i + 1)} /></div>
          ))}
        </div>
      </div>
    </section>
  );
}
